import { getFunctions, httpsCallableFromURL } from 'firebase/functions'
import { ensureFirebase } from './firebase'
import type { DataCapture, RenderOptions, SubmissionPayload } from './types'

export async function fetchDataCapture(opts: RenderOptions): Promise<DataCapture> {
  const app = ensureFirebase()
  const functions = getFunctions(app, 'eu-west-1')
  const getFormInfo = httpsCallableFromURL(functions, 'https://getforminfo-zxayxva5ha-ew.a.run.app')
  try {
    const res = await getFormInfo({ eventId: opts.eventId })
    // Accept either { data_capture: {...} } or raw object
    const dc = (res?.data?.data_capture ?? res?.data ?? {}) as DataCapture
    return dc
  } catch (err) {
    console.warn('error ' + JSON.stringify(err))
    throw err
  }
}

export async function postSubmission(submitUrl: string, payload: SubmissionPayload): Promise<T> {
  const app = ensureFirebase()
  const functions = getFunctions(app, 'eu-west-1')
  const submitEntry = httpsCallableFromURL(functions, 'https://submitentry-zxayxva5ha-ew.a.run.app')

  try {
    const result = await submitEntry(payload)
    return result
  } catch (err: any) {
    console.warn('submit error ' + JSON.stringify(err))
    return err
  }
}
